import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs';

import * as AuthActions from '../actions/auth.actions';
import { AuthenticationService } from '../../service/authentification.service';
import { HttpResponse } from '@angular/common/http';
import { AuthResponse } from '../../model/auth.model';

@Injectable()
export class AuthEffects {

    constructor(
        private actions$: Actions,
        private _authentificationService: AuthenticationService,
        private _router: Router,
    ) { }

    loginSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.loginSuccess),
            map((action) => {
                this._authentificationService.xBundleRecurring = action.payload.xBundleRecurring;
                this._authentificationService.accessToken = action.payload.access_token;
            }),
            catchError(() => of(AuthActions.loginFailure(null))),
        ), { dispatch: false }
    );

    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.login),
            exhaustMap((action) =>
                this._authentificationService.lilateLogin(action.credentials).pipe(
                    map((authResponse: HttpResponse<AuthResponse>) => {
                        return AuthActions.loginSuccess(
                            {
                                payload: {
                                    access_token: authResponse.body.access_token,
                                    xBundleRecurring: authResponse.headers.get('x-bundle-recurring')
                                }
                            });
                    }),
                    catchError((error) => of(AuthActions.loginFailure(error.error)))
                )
            )
        )
    );

    updateBundleRecurring$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.updateBundleRecurring),
            map((action) => {
                this._authentificationService.xBundleRecurring = action.xBundleRecurring;
            }),
        ), { dispatch: false }
    );

    // refreshToken$ = createEffect(() =>
    //   this.actions$.pipe(
    //     ofType(AuthActions.refreshToken),
    //     exhaustMap(() =>
    //       this._authService.signInUsingToken().pipe(
    //         map((authResponse: AuthResponse) => {
    //           return AuthActions.loginSuccess({ payload: authResponse });
    //         }),
    //         catchError(() => of(AuthActions.loginFailure({ error: null })))
    //       )
    //     )
    //   )
    // );
}

